import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TipPopService {

  // 提示框
  public popBox: {
    status: boolean,
    type: 'success' | 'warning' | 'loading',
    text: string,
    top: number,
    direc: 'top' | 'bottom',
  } = { status: false, type: 'success', text: '', top: 0, direc: 'top' }

  // 提示气泡框
  public tipPop(text: string, type: 'success' | 'warning' | 'loading' = 'success', top?: number, direc?: 'top' | 'bottom') {
    if (this.popBox.type === 'loading') { this.popBox.status = false }
    if (this.popBox.status) { return }

    this.popBox.text = text
    this.popBox.status = true
    this.popBox.type = type
    top && (this.popBox.top = top)
    direc && (this.popBox.direc = direc)

    if (type !== 'loading') {
      setTimeout(() => {
        this.popBox.status = false
        this.popBox.text = ''
        this.popBox.type = 'success'
        this.popBox.top = 0
        this.popBox.direc = 'top'
      }, 1500)
    }
  }

}
